<div class="panel-container">
    <div  class="panel-title">
        <h3>
            CANNOT CONVERT
            <span (click)="cancel()" id="close-popup">
                <i class="material-icons close-icon">close</i>
            </span>
        </h3>
    </div>

    <div class="panel-content">
        <p>
            The policy you are attempted to convert may have been converted or deprecated.
            <br />
            Please return to the case details page to ensure you are converted the latest draft.
        </p>
    </div>

    <div class="col-md-12 footer">
        <div class="row">
            <div class="col-12 center">
                <button type="button" class="col-md-3 white-button" (click)="cancel()">
                    <span style="font-size: 16px; position: relative; bottom: 1px; letter-spacing: 0.4px; color: #292929">Cancel</span>
                </button>
                <button type="button" class="col-md-3 frontend-primary-button" (click)="viewCase()" style="height: 40px; font-size: 15px;">
                    Return to Case
                </button>
            </div>
        </div>
        
    </div>

</div>